import { Popover } from 'antd';
import React, { useRef } from 'react';
import { getPopupContainer } from '../../../../../helpers/popUp';
import { isProxy } from 'datastake-daf/src/helpers/Token';
import { TooltipEvent, Style, getColors } from '../../../../../screens/Analysis/components/scl-components/stack-chart';
import { useModule } from '../../../../../helpers/user';

const colors = getColors('INCIDENTS');

const getColor = (item) => {
  return colors[item] || '';
}

const getArray = (val = 0, length = 0) => {
  if (Array.isArray(val)) {
    const dif = 100 - length;
    if (dif <= 0) {
      return {
        arr: [],
        length: 100,
      };
    }

    const _arr = val.slice(0, dif);
    return {
      arr: _arr,
      length: _arr.length + length,
    };
  }

  const arr = [];

  for (let i = 0; i < val; i++) {
    arr.push(i);
  }

  return {
    arr,
    length: arr.length,
  };
};

const mode = isProxy() ? 'proxy' : 'app';

export default function StackChart({
  data = {},
}) {
  const ref = useRef();
  const { mod } = useModule();

  let max = 0;

  const getEventHeight = () => {
    const MARGIN = 2;
    const height = Math.abs(parseFloat(((300 - max * MARGIN) / max).toFixed(2)));
    return height > 35 ? 35 : height;
  }

  const content = () => {
    const {
      major,
      moderate,
      minor,
    } = data || {};

    const _keys = Object.keys(minor || moderate || major || {});

    const _d = _keys.reduce((all, name) => {
      const { arr: _moderateArray } = getArray((moderate || {})[name], 0);
      const { arr: _majorArray } = getArray((major || {})[name], _moderateArray.length);
      const { arr: _minorArray, length } = getArray((minor || {})[name], _moderateArray.length + _majorArray.length);

      if (length > max) {
        max = length;
      }

      all[name] = {
        _moderateArray,
        _majorArray,
        _minorArray,
      };

      return all;
    }, {});

    const height = getEventHeight();

    return _keys.map((name) => {
      const {
        _moderateArray,
        _majorArray,
        _minorArray,
      } = _d[name];

      return (
        <div className="weekDay" key={name}>
          <div className="dayCol">
            {_minorArray.map((id) => (
              <Popover
                {...getPopupContainer()}
                content={(
                  <TooltipEvent
                    dateKey="createdAt"
                    ev={typeof id === 'object' ? id : { datastakeId: 'Comming Soon', title: 'Comming Soon' }}
                    colors={colors}
                    mod={mod}
                    mode={mode}
                  />
                )}
                key={`${typeof id === 'object' ? id?.datastakeId : id}-${name}-minor`}
              >
                <div
                  className="event"
                  style={{
                    background: getColor('minor'),
                    height: `${height}px`
                  }}></div>
              </Popover>
            ))}
            {_majorArray.map((id) => (
              <Popover
                {...getPopupContainer()}
                content={(
                  <TooltipEvent
                    dateKey="createdAt"
                    ev={typeof id === 'object' ? id : { datastakeId: 'Comming Soon', title: 'Comming Soon' }}
                    mod={mod}
                    mode={mode}
                    colors={colors} />
                )}
                key={`${typeof id === 'object' ? id?.datastakeId : id}-${name}-minor`}
              >
                <div
                  className="event"
                  style={{
                    background: getColor('major'),
                    height: `${height}px`,
                  }}></div>
              </Popover>
            ))}
            {_moderateArray.map((id) => (
              <Popover
                {...getPopupContainer()}
                content={(
                  <TooltipEvent
                    mod={mod}
                    mode={mode}
                    dateKey="createdAt"
                    ev={typeof id === 'object' ? id : { datastakeId: 'Comming Soon', title: 'Comming Soon' }}
                    colors={colors} />
                )}
                key={`${typeof id === 'object' ? id?.datastakeId : id}-${name}-minor`}
              >
                <div
                  className="event"
                  style={{
                    background: getColor('moderate'),
                    height: `${height}px`,
                  }}></div>
              </Popover>
            ))}
          </div>
          {name}
        </div>
      )
    });

  };

  return (
    <Style className="riskProfile" ref={ref}>
      <div className="timeline">
        {content()}
      </div>
    </Style>
  );
}
